module.exports = __webpack_public_path__ + "img/SUB-m.49789240.png";